<template>
  <nav class="navbar min-w-1400">
    <div class="secondBox max-w-1400">
      <div class="logo">
        <!-- <img
          :src="require('@/page/betacreditdinero/components/img/logo.png')"
          :alt="logo"
          class="logoImg"
        /> -->
        <span class="title">Ruart Ecuador S.A.S.</span>
        <!-- <div class="titleBox">
          <span>PROSPERITY AND GROWTH</span>
          <span>COMMERCIAL JOINT STOCK BANK</span>
        </div> -->
      </div>
      <ul class="nav-links">
        <li :class="{ 'active-link': isActive('/') }" class="Li1">
          <router-link to="/" class="nav-link1">
            <span class="routeText1">Productos de préstamo</span>
          </router-link>
        </li>
        <li :class="{ 'active-link': $route.path === '/about' }" class="Li2">
          <router-link to="/about" class="nav-link2">
            <span class="routeText2">A nosotros</span>
          </router-link>
        </li>
        <li :class="{ 'active-link': $route.path === '/coment' }" class="Li5">
          <router-link to="/coment" class="nav-link5">
            <span class="routeText5">Comentarios y quejas</span>
          </router-link>
        </li>
        <li :class="{ 'active-link': $route.path === '/question' }" class="Li3">
          <router-link to="/question" class="nav-link3">
            <span class="routeText3">Centro de problemas</span>
          </router-link>
        </li>
        <li :class="{ 'active-link': $route.path === '/protocol' }" class="Li4">
          <!-- <router-link to="/protocol" class="nav-link4">
            <span class="routeText4">Acuerdo de privacidad</span>
          </router-link> -->
          <a href="https://www.ruartecuador.com/Privacy-ios/" class="nav-link3" target="_blank">
            <span class="routeText4">Acuerdo de privacidad</span>
          </a>
        </li>
      </ul>
    </div>
    <!-- <div style="height: 130px"></div> -->
  </nav>
</template>

<script>
export default {
  data() {
    return {
      link1Color: "white",
    };
  },
  methods: {
    isActive(route) {
      return this.$route.path === route;
    },
  },
};
</script>
<style scoped>
.navbar {
  display: flex;
  justify-content: center;
  width: 100%;
  background-color: "";
  height: 90px;
  position: sticky;
  top: 0;
  z-index: 1000;
}

.secondBox {
  display: flex;
  width: 100%;
  justify-content: space-between;
  /* height: 90px; */
  padding: 0 15px;
  background-color: #ffffff;
  /* box-shadow: 0px 2px 28px rgba(50, 55, 71, 0.10); */
}

.logo {
  font-weight: bold;
  color: black;
  display: flex;
  align-items: center;
}

.logoImg {
  width: 60px;
  height: 60px;
  margin-left: 30px;
}

.title {
  width: 500px;
  /* height: 24px; */
  font-size: 18px;
  font-family: DM Sans-Bold;
  font-weight: 600;
  color: #333536;
  /* line-height: 23px; */
  padding-left: 17px;
  /* text-transform: uppercase; */
  /* line-height: 35px; */
  height: 90px;
  line-height: 90px;
}

.routeText1,
.routeText2,
.routeText3,
.routeText4,
.routeText5 {
  font-size: 16px;
  font-family: SF Pro-Semibold;
  font-weight: 550;
  color: #333333;
  opacity: 0.8;
  /* line-height: 29px; */
  /* text-transform: uppercase; */
}

.nav-link1,
.nav-link2,
.nav-link3,
.nav-link4,
.nav-link5 {
  text-decoration: none;

  margin: 0 auto;
}

.nav-links {
  list-style: none;
  display: flex;
  align-items: center;
  /* 垂直居中对齐 */
  justify-content: center;
  /* 水平居中对齐 */
}

.nav-links li {
  display: flex;
  /* padding: 6px; */
  background-size: 100% 100%;
  background-repeat: no-repeat;
  /* height: 39px; */
  padding-left: 4px;
  padding-right: 4px;
  line-height: 90px;
}
.Li1 {
  width: 230px;
}
.Li2 {
  width: 150px;
}
.Li3 {
  width: 210px;
}
.Li4 {
  width: 240px;
  /* 这个如果给margin-right底部可能会出现边距的问题 */
}
.Li5 {
  width: 210px;
  /* 这个如果给margin-right底部可能会出现边距的问题 */
}
.active-link {
  border-color: #ffd65b;
  background-color: #ffd65b;
  /* border-radius: 40px; */
  /* border-radius: 10px; */
  /* background-image: url("@/page/thaiintercompany/components/img/NavActive.png"); */
  background-repeat: no-repeat;
  background-size: 100% 100%;
}

.active-link .routeText1,
.active-link .routeText2,
.active-link .routeText3,
.active-link .routeText4,
.active-link .routeText5 {
  font-family: Inter-Extra Bold;
  color: #333333;
  opacity: 1;
}
.title {
  /* border: 1px solid red; */
  /* padding-left: 110px; */
  width: 230px;
}
.titleBox {
  display: flex;
  flex-direction: column;
  padding-left: 160px;
  font-size: 18px;
  font-family: DM Sans-Bold;
  font-weight: 600;
  color: #292b33;
  /* border: 1px solid red; */
}
.secondBox {
  padding: 0 100px 0 100px;
  /* border-bottom: 2px solid #AFB0B2; */
  box-shadow: 0px 3px 11.3px 0px rgba(64, 64, 65, 0.15);
}
</style>